module.exports = __webpack_public_path__ + "img/f1.40cc3122.png";